import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api.tsx";
import ProductCard from "../components/ProductCard.tsx";
import { useAuth } from "../contexts/AuthContext.tsx";
import { useCart } from "../contexts/CartContext.tsx";
import { useError } from "../contexts/ErrorContext.tsx";
import { useSuccess } from "../contexts/SuccessContext.tsx";
import { getDiscountedPrice } from "../utils/price.tsx";

const SearchPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("search")?.toLocaleLowerCase("tr") || "";
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const { isAuthenticated } = useAuth();
  const { addToCart } = useCart();
  const { setError } = useError();
  const { addSuccess } = useSuccess();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get("/api/product");
        setProducts(res.data);
      } catch (error) {
        setError("Ürünler alınamadı.");
      }
    };
    fetchProducts();
  }, [setError]);

  useEffect(() => {
    if (!query || query.length < 2) {
      setFiltered([]);
      return;
    }
    setFiltered(
      products.filter((p) =>
        [p.name, p.category, p.brand, p.description]
          .map(x => x?.toLocaleLowerCase("tr") || "")
          .some(val => val.includes(query))
      )
    );
  }, [products, query]);

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-2 md:px-8 py-6">
        <h2 className="text-2xl font-bold mb-6 text-center">
          "{query}" için arama sonuçları
        </h2>
        {filtered.length === 0 ? (
          <div className="text-center text-gray-500">Sonuç bulunamadı.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filtered.map((product) => (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                imageUrl={product.imageUrl}
                price={product.price}
                discountRate={product.discountRate}
                campaignName={product.campaignName}
                campaignEndDate={product.campaignEndDate}
                brand={product.brand}
                category={product.category}
                participantCount={product.participantCount}
                maxUserCount={product.maxUserCount}
                isAuthenticated={isAuthenticated}
                hasCampaign={!!product.campaignId}
                onAddToCart={async (quantity) => {
                  try {
                    const response = await addToCart({
                      id: product.id,
                      productId: product.id,
                      name: product.name,
                      price: product.price,
                      stock: product.stock,
                      finalPrice: getDiscountedPrice(product.price, product.discountRate) || product.price,
                      quantity,
                      ...(product.campaignId && { campaignId: product.campaignId }),
                      depositRate: product.depositRate || 0
                    });
                    if (response?.success || response?.status === 200) {
                      addSuccess("Ürün sepete eklendi!");
                    }
                  } catch (err) {
                    setError("Ürün sepete eklenemedi!");
                  }
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;